import * as turf from '@turf/turf'
import { message } from 'antd'
import { FeatureCollection, Point } from 'geojson'
import { useEffect, useState } from 'react'

import { PROPERTY_TYPES } from '../../../../common/drmTypes'
import { setCadastralFilter } from '../../../../redux/cadastralFilterSlice'
import { useAppDispatch } from '../../../../redux/hooks'
import { RuianQuery, RuianQueryInputGeometry } from '../util/RuianQuery'

export function useBuildingPoints(
  where: string,
  shouldFetch: boolean,
  geometryFilter?: RuianQueryInputGeometry | null
): [boolean, FeatureCollection<Point>] {
  const [loading, setLoading] = useState(false)
  const [buildings, setBuildings] = useState(turf.featureCollection<Point>([]))
  const dispatch = useAppDispatch()

  useEffect(() => {
    fetchBuildingPoints()
    async function fetchBuildingPoints() {
      try {
        setLoading(true)
        if (!shouldFetch) return
        if (!where || where === '') {
          setBuildings(turf.featureCollection([]))
          return
        }
        let query = RuianQuery.StavebnihoObjektuDefinicniBod.outFields([
          'objectid',
        ]).where(where)
        if (geometryFilter) {
          query = query.layerInputGeometry(geometryFilter)
        }

        const params = await query.getFinalSearchParamsForRequest()
        const geojson = await query.asGeoJson()

        setBuildings(geojson)

        dispatch(
          setCadastralFilter({
            whereClause: JSON.stringify(Object.fromEntries(params.entries())),
            count: geojson?.features?.length || 0,
            propertyType: PROPERTY_TYPES.BUILDING,
          })
        )
      } catch (error) {
        console.error(error)
        message.error('Nepodařilo se načíst body stavebního objektu')
        setBuildings(turf.featureCollection([]))
      } finally {
        setLoading(false)
      }
    }
    // Not really sure, but if I pass shouldFetch and even if I exit early it causes expensive re-fetch
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [where, geometryFilter])

  return [loading, buildings]
}
